export default __webpack_public_path__ + "static/media/logo25.366a9e16.svg";